/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=51a6a190"
const script = {}

import "./App.vue?vue&type=style&index=0&id=51a6a190&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4+webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__